import { createGlobalStyle } from 'styled-components';
import RobotoBold from '../assets/fonts/Roboto-Bold.ttf';
import RobotoLight from '../assets/fonts/Roboto-Light.ttf';
import RobotoMedium from '../assets/fonts/Roboto-Medium.ttf';
import RobotoRegular from '../assets/fonts/Roboto-Regular.ttf';
import RobotoThin from '../assets/fonts/Roboto-Thin.ttf';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  @font-face {
    font-family: 'Roboto Bold';
    src: local('Roboto Bold'), url(${RobotoBold}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Light';
    src: local('Roboto Light'), url(${RobotoLight}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Medium';
    src: local('Roboto Medium'), url(${RobotoMedium}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Regular';
    src: local('Roboto Regular'), url(${RobotoRegular}) format('truetype');
  }

  @font-face {
    font-family: 'Roboto Thin';
    src: local('Roboto Thin'), url(${RobotoThin}) format('truetype');
  }

  * {
    box-sizing: border-box;
  }
`;

export default GlobalStyle;
